
@switch (columnId) {
  @case ('name') {
    <lib-text-table-column>
      {{ report.name }}
    </lib-text-table-column>
  }
  @case ('description') {
    <lib-text-table-column>
      {{ report.description }}
    </lib-text-table-column>
  }
  @case ('download') {
    <lib-vitu-tooltip text="Download">
      <i class="far fa-file-download global-table-cell-image-link" (click)="onClickDownload()"></i>
    </lib-vitu-tooltip>
  }
  @default {
  }
}
